module.exports = __webpack_public_path__ + "img/callcenter-icon.518bdf18.png";